(function($) {
  "use strict";

  var bodyEl = $("body"),
    openbtn = $("#open-extra-menu-btn"),
    closebtn = $("#close-extra-menu-btn"),
    closelayer = $("#close-extra-menu-layer"),
    isOpen = false,
    morphEl = $("#morph-shape")[0],
    s = Snap($(morphEl).find("svg")[0]),
    path = s.select("path"),
    starterPath = $(".morph-shape svg path").attr("d"),
    steps = $(morphEl)
      .attr("data-morph-open")
      .split(";"),
    stepsTotal = steps.length,
    isAnimating = false;

  function initElasticMenu() {
    openbtn.on("click", toggleMenu);
    if (closebtn) {
      closebtn.on("click", toggleMenu);
    }
    if (closelayer) {
      closelayer.on("click", toggleMenu);
    }
  }

  function toggleMenu() {
    if (isAnimating) {
      return false;
    }

    isAnimating = true;
    if (isOpen) {
      bodyEl.removeClass("show-extramenu");

      // animate path
      setTimeout(function() {
        // reset path
        $(".morph-shape svg path").attr("d", starterPath);
        isAnimating = false;
      }, 400);
    } else {
      bodyEl.addClass("show-extramenu");
      // animate path
      var pos = 0,
        nextStep = function(pos) {
          if (pos > stepsTotal - 1) {
            isAnimating = false;
            return;
          }
          path.animate(
            { path: steps[pos] },
            pos === 0 ? 400 : 500,
            pos === 0 ? mina.easein : mina.elastic,
            function() {
              nextStep(pos);
            }
          );
          pos++;
        };

      nextStep(pos);
    }
    isOpen = !isOpen;
  }

  function checkMenu() {
    if ($(document).scrollTop() > 0) {
      $(".navbar").addClass("scrolled");
    } else {
      $(".navbar").removeClass("scrolled");
    }
  }

  /* Hiding the header when scrolling donw */
  var headroomElements = document.querySelectorAll(".js-hide-header");

  headroomElements.forEach(function(element) {
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(element, {
      offset: 300,
      tolerance: 15,
    });
    // initialise, only on mobile
    if ($(window).width() < 992) {
      headroom.init();
    }

    $(window).resize(function() {
      headroom.destroy();
      if ($(window).width() < 992) {
        headroom.init();
      }
    });
  });

  $(function() {
    checkMenu();

    if (
      $(".template-single-programs").length &&
      $(".js-tickets-mobile").length
    ) {
      var ticketsElement = document.querySelector(".js-tickets-mobile");
      var headroomTickets = new Headroom(ticketsElement, {
        offset: 0,
        tolerance: {
          up: 5,
          down: 5,
        },
        classes: {
          unpinned: "headroomtickets--unpinned",
          bottom: "headroomtickets--bottom",
          notBottom: "headroomtickets--not-bottom",
        },
      });
      headroomTickets.init();
    }

    $(window).scroll(function() {
      checkMenu();
    });

    initElasticMenu();

    $(".js-mobile-location-map").on("click", function() {
      $(".location_map-wrapper").toggleClass("opened");

      if ($(".location_map-wrapper").hasClass("opened")) {
        $(".js-mobile-location-map").text("Vissza");
      } else {
        $(".js-mobile-location-map").text("Alaprajz");
      }
    });

    $("#akvarium-map a").on("click", function() {
      $(".js-mobile-location-map").trigger("click");
    });
  });
})(jQuery);
